import React, {useState,useEffect,useContext} from "react";
import Modal from "react-bootstrap/Modal";

import Lang from '../../lang/translations';
import Context from '../../context/context';
import helpersFunction from '../../_helpers/helpersFunction';
import CryptoJS from "react-native-crypto-js";
import FormCities from "../../form/formSelectCity"

export default function Pushtelegram(props) {

    const [regioni, setRegioni] = useState({});
    // Aggiungiamo dropdown per sono/cerco
    const [sono, setSono] = useState("uomo");
    const [cerco, setCerco] = useState("donna");

    // testo delle <option>: Lang con var:true ritorna una stringa pura
    const uomo  = Lang({ w: "uomo",  page: "profilo", var: true });
    const donna = Lang({ w: "donna", page: "profilo", var: true });
      
    const  context = useContext(Context)


        useEffect(() => { 
          
          helpersFunction.getRegionsByCountry()
            .then(res => {
                setRegioni(res)
          })
    
        },[]);

        function handleInputChange(target) {
            const value = target.currentTarget.value;
            var token = localStorage.getItem('token')
		        var trackerId = localStorage.getItem('trackerId')

            fetch(process.env.REACT_APP_APIADDRESS+"/users/updateRegion/"+trackerId, {
              method: 'put',
              headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+ token
              },
              body: JSON.stringify({region:value})
              })
              .then(response => response.json()) 
              .then(res => {
                let bytes  = CryptoJS.AES.decrypt(res.user, process.env.REACT_APP_CHIAVE_CRIPTAZIONE);
                let user = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));  
                
                if(!res.result){
                  return
                }else{
                  
                  helpersFunction.setUser(user,context,true,true)
                  context.setVerifiedUser(true)
                  context.setModalShowHook(false)
                  
                }
                
              });
        }

    return (  <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="popuphook"
      >
        <Modal.Body>
          <div className="popupbackground" >
              <div className="contentBackground formSignup">
                  <div className="hookTextContainer">
                    <h1><Lang w={"quasi_terminato"} page={"popupHook"}/></h1>
                    <h3><Lang w={"imposta_regione"} page={"popupHook"}/></h3>
                  </div>
                  <div className="sonoCercoContainer">
                    <label><Lang w={"sono"} page={"signupForm"}/></label>
                    <select name="sono" value={sono} onChange={(e) => setSono(e.target.value)}>
                      <option value="uomo">{uomo}</option>
                      <option value="donna">{donna}</option>
                    </select>

                    <label><Lang w={"cerco"} page={"signupForm"}/></label>
                    <select name="cerco" value={cerco} onChange={(e) => setCerco(e.target.value)}>
                      <option value="donna">{donna}</option>
                      <option value="uomo">{uomo}</option>
                    </select>
                  </div>
                  <FormCities 
                    extraData={{ sono, cerco }}
                    onChange={
                      (user) =>{ 
                        console.log("dfldfk",user);
                        helpersFunction.setUser(user,context,true,true);
                        context.setModalShowHook(false);
                      }
                    }/>
                 
              </div>
          </div>
        </Modal.Body>
      </Modal>);

}